// "Mailable now" is the number an owner reads before sending, so it doubles as
// the way into that exact list — otherwise it's a figure you have to trust
// without being able to see who it means.
export default function ContactStat({ label, value, hint, emphasis = false, onClick, active = false }) {
  const body = (
    <>
      <div className="text-xs uppercase tracking-wide text-muted-foreground">{label}</div>
      <div className={`mt-1 text-2xl font-semibold ${emphasis ? 'text-[var(--teal-11)]' : ''}`}>
        {value === null ? '—' : value.toLocaleString()}
      </div>
      {hint && <div className="mt-0.5 text-xs text-muted-foreground">{hint}</div>}
    </>
  )
  const shell = `rounded-lg border bg-card px-4 py-3 text-left ${
    active ? 'border-primary ring-1 ring-primary' : 'border-border'
  }`

  if (!onClick) return <div className={shell}>{body}</div>
  return (
    <button type="button" onClick={onClick} className={`${shell} w-full transition-colors hover:bg-muted/50`}
      aria-pressed={active}>
      {body}
    </button>
  )
}
